"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const securityImage = require("./security.svg");
const utilities_1 = require("./utilities");
const react_apollo_1 = require("react-apollo");
const EmptyState = require("@atlaskit/empty-state").default;
const permissionQuery = require("./service-permission.query.graphql");
const loading_1 = require("../../loading");
const utilities_2 = require("../../utilities");
exports.withSuffcientServicePermission = (permission) => (Component) => utilities_2.compose(react_apollo_1.graphql(permissionQuery), loading_1.withLoadingSpinner)(class WithSufficientServicePermission extends React.Component {
    render() {
        if (this.props.data.service &&
            !utilities_1.isSufficientPermission(this.props.data.service.currentUserPermission, permission)) {
            return (React.createElement(EmptyState, { header: "You do not have permission to view this page", description: "Contact the service team to get permission", imageUrl: securityImage, maxImageWidth: 300, maxImageHeight: 300 }));
        }
        else {
            return React.createElement(Component, Object.assign({}, this.props));
        }
    }
});
exports.withSufficientServicePermission = exports.withSuffcientServicePermission;
